
<template>
  <div class="box-content shadow-box sidebar-margin container column hidden feed">
      <div class="feed-content__title animation-fade animation-delay-1 container">
        <p>
          <span>News</span>
          <div style="font-size: 13px;margin-left: 10px;">
            {{ $toDate(new Date(article.publishedDate)) }}
          </div>
        </p>
        <hr>
      </div>

      <div class="container feed-box">

        <div class="feed-box_base">
          <div class="container feed-box_base_etiqueta">
            <div class="feed-box_base_etiqueta_tipe blue">
              Notice
            </div>
            <div class="feed-box_base_etiqueta_prev blue" :class="{ disabled: !canBack }" @click="prevItem()">
              <img src="@/assets/img/icons/twoarrow.svg" height="13px" alt="Previous">
            </div>
            <div class="feed-box_base_etiqueta_next blue" :class="{ disabled: !canNext }" @click="nextItem()">
              <img src="@/assets/img/icons/twoarrow.svg" height="13px" alt="Next">
            </div>
          </div>
          <div class="container container feed-box_base_etiqueta_text">
            {{ article.title }}
          </div>
        </div>
        <div class="feed-box_base">
          <div class="container feed-box_base_etiqueta">
            <div class="feed-box_base_etiqueta_tipe orange">
              Article
            </div>
            <div class="feed-box_base_etiqueta_prev orange" :class="{ disabled: !canBackContent }" @click="prevContent()">
              <img src="@/assets/img/icons/twoarrow.svg" height="13px" alt="Previous">
            </div>
            <div class="feed-box_base_etiqueta_next orange" :class="{ disabled: !canNextContent }" @click="nextContent()">
              <img src="@/assets/img/icons/twoarrow.svg" height="13px" alt="Next">
            </div>
          </div>
          <div class="container container feed-box_base_etiqueta_text article" v-html="content">
          </div>
        </div>
        
      </div>
  </div>
</template>



<script>
import { mapGetters } from 'vuex'
import metaPercentage from '@/components/metaPercentage'

export default {
  name: 'buttonComponent',
  data () {
    return {
      statusTeacher: true,
      contentPosition: 0
    }
  },
  computed: {
    ...mapGetters({
      'article': 'feed/current',
      'canNext': 'feed/canNext',
      'canBack': 'feed/canBack'
    }),
    arrContent () {
      if (!this.article || !this.article.content) return []
      let text = this.article.content
      text = text.replace(/<ol>|<\/ol>/g, '')
      return text.split('<li>')
                 .filter(i => !!i)
                 .map(i => i.replace(/<\/li>/g, ''))
    },
    canNextContent () {
      return this.contentPosition < (this.arrContent.length - 1)
    },
    canBackContent () {
      return this.contentPosition > 0
    },
    content () {
      return this.arrContent[this.contentPosition] || 'None'
    }
  },
  components: {
    metaPercentage
  },
  methods: {
    prevItem () {
      if (this.canBack) {
        this.contentPosition = 0
        this.$store.commit('feed/prevPosition')
      }
    },
    nextItem () {
      if (this.canNext) {
        this.contentPosition = 0
        this.$store.commit('feed/nextPosition')
      }
    },
    nextContent () {
      if (this.canNextContent) {
        this.contentPosition++
      }
    },
    prevContent () {
      if (this.canBackContent) {
        this.contentPosition--
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.borda{
  border: 1px solid royalblue;
}
.feed {
  height: 409px !important;
  &-content {
    max-height: 100%;
    &__title {
      cursor: pointer;
      transition: 0.3s;
      transform-style: preserve-3d;
      color: #255F83;
      font-size: 14px;
      span {
        font-weight: 900;
        background: #1483a0;
        padding: 5px 15px;
        border-radius: 50px;
        color: white;
        font-weight: 300;
      }
    }
  }
  hr {
    margin: 15px 0px;
    background: #dadada;
    border: none;
    padding: 1px;
    border-radius: 100px;
  }
  &-box{
    width: 100%;
    height: 100%;
    border-radius: 15px;
    padding: 10px;
    border: 1px solid #bfbfbf;
    flex-direction: column;
    &_base{
      width: 100%;
      height: 100%;
      justify-content: center;
      -webkit-box-flex: 1;
      display: flex;
      flex-direction: column;
      flex-grow: 1;
      align-items: center;
      &_etiqueta{
        // justify-content: space-around;
        width: 100%;
          &_tipe{
            padding: 5px 25px;
            border-radius: 50px;
            color: white;
            font-weight: 300;
            width: 100%;
            &.blue{
              background: #0E9AAA;
            }
            &.orange{
              background: orange;
            }
          }
          &_next{
            cursor: pointer;
            padding: 5px 12px;
            justify-content: center;
            align-items: center;
            display: flex;
            border-radius: 50px;
            color: white;
            font-weight: 300;
            &.blue{
              background: #0E9AAA;
            }
            &.orange{
              background: #FF6600;
            }
            &.disabled {
              color: #AAA;
              &:hover {
                cursor: not-allowed;
                background-color: #6f6f6f;
              }
            }
            &:hover{
              filter: brightness(1.5);;
            }    
          }
          &_prev{
            cursor: pointer;
            padding: 5px 12px;
            justify-content: center;
            align-items: center;
            display: flex;
            border-radius: 50px;
            color: white;
            font-weight: 300; 
            margin: 0px 5px; 
            img{
              transform: rotate(180deg);
            }
             &.blue{
              background: #0E9AAA;
            }
            &.orange{
              background: #FF6600;
            }
            &.disabled {
              color: #AAA;
              &:hover {
                cursor: not-allowed;
                background-color: #6f6f6f;
              }
            }
            &:hover{
              filter: brightness(1.5);;
            }         
          }
          &_text{
            max-height: 115px;
            min-height: 115px;
            overflow-y: scroll;
            overflow-x: hidden;
            // align-items: center;
            font-size: 14px;
            font-weight: 300;
            line-height: 17px;
            padding: 5px 5px;
            margin: 10px 0px;
            &::-webkit-scrollbar {
              width: 10px;
            }
            
            &::-webkit-scrollbar-thumb {
              background: #666;
              border-radius: 20px;
            }

            &::-webkit-scrollbar-track {
              background: #ddd;
              border-radius: 20px;
            }
            &.article{
              background: #dedede;
              font-weight: 200;
              font-size: 13px;
              border-radius: 10px 5px 5px 10px;
              flex-direction: column;
              margin-bottom: 0px;
              a {
                color: black!important;
              }
            }
          }
        }
      
    }
  }
}
// .feed {
//   height: 409px !important;
//   &-content {
//     max-height: 100%;
//     &__title {
//       cursor: pointer;
//       transition: 0.3s;
//       transform-style: preserve-3d;
//       color: #255F83;
//       font-size: 14px;
//       span {
//         font-weight: 900;
//         background: #1483a0;
//         padding: 5px 15px;
//         border-radius: 50px;
//         color: white;
//         font-weight: 300;
//       }
//     &__article {
//       position: relative;
//       height: calc(100% - 20px);
//       border: 3px solid #DFDFDF;
//       padding: 5px;
//       border-radius:  10px;
//       &__prev, &__next {
//         font-size: 24px;
//         position: absolute;
//         padding: 5px 12.5px;
//         border-radius: 25px;
//         background-color: #FFF;
//         transition: all .2s;
//         top: 57.5%;
//         &.disabled {
//           color: #AAA;
//           &:hover {
//             cursor: not-allowed;
//             background-color: #EFEFEF;
//           }
//         }
//         &:hover {
//           cursor: pointer;
//           background-color: #DFDFDF;
//         }
//       }
//       &__prev {
//         left: -10%;
//         padding-left: 11px;
//         padding-right: 14px;
//       }
//       &__next {
//         left: 92%;
//         padding-left: 14px;
//         padding-right: 11px;
//       }
//       &__text {
//         margin: 0 5px;
//         height: 100%;
//         max-height: 100%;
//         &__title {
//           word-break: break-word;
//           margin: 0 5px;
//           height: 30%;
//           overflow-y: auto;
//           &::-webkit-scrollbar {
//             width: 10px;
//           }
//           &::-webkit-scrollbar-track {
//             border-radius: 8px;
//             background: #DDD;
//           }
//           &::-webkit-scrollbar-thumb {
//             border-radius: 10px;
//             background-color: rgba(0,0,0,0.15);
//           }
//         }
//         &__item {
//           padding-top: 5px;
//           height: calc(70% - 19px);
//           max-height: calc(70% - 19px);
//           &__prev, &__next {
//             padding: 0 5px;
//             border-radius: 10px;
//             background-color: #DFDFDF;
//             width: 100%;
//             &.disabled {
//               color: #AAA;
//               background-color: #EFEFEF;
//               &:hover {
//                 cursor: not-allowed;
//               }
//             }
//             &:hover {
//               cursor: pointer;
//             }
//           }
//           &__content {
//             padding: 10px 5px;
//             height: calc(100% - 52px);
//             &__box {
//               word-break: break-word;
//               height: 100%;
//               max-height: 100%;
//               overflow-y: auto;
//               &::-webkit-scrollbar {
//                 width: 10px;
//               }
//               &::-webkit-scrollbar-track {
//                 border-radius: 8px;
//                 background: #DDD;
//               }
//               &::-webkit-scrollbar-thumb {
//                 border-radius: 10px;
//                 background-color: rgba(0,0,0,0.15);
//               }
//             }
//           }
//         }
//       }
//       &__date {
//         text-align: center;
//       }
//     }
//   }
// }
</style>



// WEBPACK FOOTER //
// src/components/feed/index.vue